import SectorHero from "@/components/SectorHero";
import TopicGrid from "@/components/TopicGrid";
import MethodTimeline from "@/components/MethodTimeline";
import RealisationsGallery from "@/components/RealisationsGallery";
import StatsBand from "@/components/StatsBand";
import ContactSection from "@/components/ContactSection";
import { industryTopics } from "@/data/sectors";

export default function Industrie() {
  return (
    <div data-testid="industrie-page">
      <SectorHero
        kicker="01 · Industrie"
        title="Optimisez chaque kWh de vos procédés industriels."
        blurb="De la récupération de chaleur fatale à la modernisation du froid, en passant par la production d'air comprimé et les réseaux vapeur, ECONATION conçoit, finance et déploie des programmes d'efficacité énergétique sur mesure."
        image="https://images.unsplash.com/photo-1716643863806-989dd76ae093?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1OTV8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBpbmR1c3RyaWFsJTIwZmFjaWxpdHklMjBpbnRlcmlvcnxlbnwwfHx8fDE3ODI3OTA2NDR8MA&ixlib=rb-4.1.0&q=85"
        tags={["ISO 50001", "Audit BEGES", "IPMVP", "Décarbonation industrielle", "Fonds Chaleur compatible"]}
      />
      <TopicGrid
        kicker="Opérations CEE éligibles"
        title="Là où nous créons le plus d'impact sur vos sites industriels."
        topics={industryTopics}
      />
      <MethodTimeline />
      <StatsBand dark={false} />
      <RealisationsGallery limit={3} />
      <ContactSection />
    </div>
  );
}
